import styles from './Sidebar.module.scss';
import SidebarItemList from './SidebarItemList';
import { ReactNode } from 'react';

interface SidebarProps {
  sideBarContent?: ReactNode;
}

const Sidebar = ({ sideBarContent }: SidebarProps) => {
  return (
    <aside className={`${styles.sidebar} ${styles.sidebar__expanded}`}>
      <SidebarItemList />
      {sideBarContent}
    </aside>
  );
};

export default Sidebar;
